import { useState, useEffect } from "react";
import { getHistoryCollection } from "../../../services/container";
import { getSettingsData } from "../../../services/settings";
/**
 * Hook pour gérer le chargement des données de collection d'activité
 */
export const useActivityCollectionData = (
  keywordFilter,
  periodHistoryStart,
  periodHistoryStop,
  handleValidate,
  setOpenFilter = null,
  onHistoricalFluxLabels = null,
  originFilter = "all",
  onHistoricalOriginLabels = null,
  characterizationFilter = "all",
  characterizationStatusFilter = "all",
) => {
  const [isLoading, setIsLoading] = useState(true);
  const [dataContainerCollection, setDataContainerCollection] = useState([]);
  const [countDataCollection, setCountDataCollection] = useState(0);
  const [characterizationCounts, setCharacterizationCounts] = useState(null);
  const [characterizationCredits, setCharacterizationCredits] = useState(0);
  const [historicalFluxLabels, setHistoricalFluxLabels] = useState([]);

  useEffect(
    () => {
      const controller = new AbortController();
      const { signal } = controller;

      setIsLoading(true);
      if (setOpenFilter) {
        setOpenFilter(false);
      }
      if (typeof onHistoricalFluxLabels === "function") {
        onHistoricalFluxLabels([]);
      }
      if (typeof onHistoricalOriginLabels === "function") {
        onHistoricalOriginLabels([]);
      }

      getSettingsData().then((response) => {
        if (response.status === 200) {
          setCharacterizationCredits(
            response.data.settings.characterizationCredits,
          );
        }
      });

      const keywordValue =
        keywordFilter && keywordFilter.value
          ? keywordFilter.value
          : Array.isArray(keywordFilter)
            ? keywordFilter
            : [];

      const originValue =
        originFilter && originFilter !== "all" ? originFilter : undefined;
      const characterizationValue =
        characterizationFilter === "sent" ||
        characterizationFilter === "not_sent"
          ? characterizationFilter
          : undefined;
      const characterizationStatusValue =
        characterizationStatusFilter && characterizationStatusFilter !== "all"
          ? characterizationStatusFilter
          : undefined;

      getHistoryCollection(
        {
          periodStart: periodHistoryStart,
          periodStop: periodHistoryStop,
          keywordFilter: JSON.stringify(keywordValue),
          keepFirst: true,
          ...(originValue ? { origin: originValue } : {}),
          ...(characterizationValue
            ? { characterization: characterizationValue }
            : {}),
          ...(characterizationStatusValue
            ? { characterizationStatus: characterizationStatusValue }
            : {}),
        },
        signal,
      )
        .then((response) => {
          if (response.status === 200) {
            const labels = response.data.historicalFluxLabels || [];
            const originLabels = response.data.historicalOriginLabels || [];
            setDataContainerCollection(response.data.historyCollection);
            setHistoricalFluxLabels(labels);
            if (typeof onHistoricalFluxLabels === "function") {
              onHistoricalFluxLabels(labels);
            }
            if (typeof onHistoricalOriginLabels === "function") {
              onHistoricalOriginLabels(originLabels);
            }
            setCountDataCollection(response.data.historyCollection.length);
            setCharacterizationCounts(
              typeof response.data.characterizationTotalCount === "number"
                ? {
                    sent: response.data.characterizationSentCount ?? 0,
                    total: response.data.characterizationTotalCount,
                  }
                : null,
            );
            setIsLoading(false);
          }
        })
        .catch((error) => {
          if (error?.name !== "AbortError") {
            console.error(error);
          }
        });

      return () => {
        controller.abort();
        setDataContainerCollection([]);
        setCharacterizationCounts(null);
        setHistoricalFluxLabels([]);
        if (typeof onHistoricalFluxLabels === "function") {
          onHistoricalFluxLabels([]);
        }
        if (typeof onHistoricalOriginLabels === "function") {
          onHistoricalOriginLabels([]);
        }
      };
    },
    // eslint-disable-next-line
    [
      handleValidate,
      periodHistoryStart,
      periodHistoryStop,
      keywordFilter,
      originFilter,
      characterizationFilter,
      characterizationStatusFilter,
    ],
  );

  return {
    isLoading,
    dataContainerCollection,
    countDataCollection,
    characterizationCredits,
    historicalFluxLabels,
    characterizationCounts,
  };
};
